import { ReactNode } from 'react';
import { Navigate } from '@tanstack/react-router';

import { Role } from '../types';
import { useAuthContext } from '../hooks';

type RoleGuardProps = {
  requiredRoles: string[];
  children: ReactNode;
};

export default function RoleGuard({ requiredRoles, children }: RoleGuardProps) {
  const { user } = useAuthContext();

  const hasRole = user?.roles?.some((userRole: Role) => requiredRoles.includes(userRole.name));
  return hasRole ? children : <Navigate to="/403" replace />;
}
